"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mapBlocks_1 = require("../mapBlocks");
function mapToItemBankProps({ data, mappers, packages, forms, }) {
    let backgroundImage = null;
    if (data.backgroundImage?.length) {
        backgroundImage = mappers.mapBlock({
            block: data.backgroundImage?.[0],
            mappers,
        });
    }
    let mobileBackgroundImage = null;
    if (data.mobileBackgroundImage?.length) {
        mobileBackgroundImage = mappers.mapBlock({
            block: data.mobileBackgroundImage?.[0],
            mappers,
        });
    }
    return {
        mainContent: data?.mainContent &&
            mappers.mapRichText({
                richText: data.mainContent,
                mappers,
                packages,
                forms,
            }),
        children: (0, mapBlocks_1.mapBlocks)({ blocks: data.modules || [], mappers }),
        backgroundImage,
        mobileBackgroundImage,
        textColor: data?.textColor,
        mobileTextColor: data?.mobileTextColor,
        backgroundColor: data?.backgroundColor,
        jumpLinkId: data?.jumpLinkId,
        stackItemsOnMobile: data?.stackItemsOnMobile,
    };
}
exports.default = mapToItemBankProps;
